import MyAccountPersonalDetails from './MyAccountPersonalDetails';

export default MyAccountPersonalDetails;
